/**
 * Save an item to the server
 */
// TODO: Use a more specific error message based on the server response
const DEFAULT_ERROR_MESSAGE = 'Something went wrong';
export async function saveItemRequest(endpoint, contentId, contentTypeId) {
    const response = await fetch(`${endpoint}/${contentId}?contentType=${encodeURIComponent(contentTypeId)}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        const errorText = await response.text();
        try {
            const errorData = JSON.parse(errorText);
            throw new Error(JSON.stringify(errorData));
        }
        catch (parseError) {
            throw new Error(errorText || DEFAULT_ERROR_MESSAGE);
        }
    }
    const apiResponse = await response.json();
    return apiResponse.items.map((item) => ({
        contentId: item.contentId,
        contentTypeId: item.contentTypeId,
        savedDate: item.savedDate,
    }));
}
/**
 * Remove an item from the server
 */
export async function removeItemRequest(endpoint, contentId) {
    const response = await fetch(`${endpoint}/${contentId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        const errorText = await response.text();
        try {
            const errorData = JSON.parse(errorText);
            throw new Error(JSON.stringify(errorData));
        }
        catch (parseError) {
            throw new Error(errorText || DEFAULT_ERROR_MESSAGE);
        }
    }
    const apiResponse = await response.json();
    return apiResponse.items.map((item) => ({
        contentId: item.contentId,
        contentTypeId: item.contentTypeId,
        savedDate: item.savedDate,
    }));
}
/**
 * Refresh saved items from the server
 */
export async function refreshItems(refreshEndpoint) {
    const response = await fetch(refreshEndpoint, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        const errorText = await response.text();
        try {
            const errorData = JSON.parse(errorText);
            throw new Error(JSON.stringify(errorData));
        }
        catch (parseError) {
            throw new Error(errorText || DEFAULT_ERROR_MESSAGE);
        }
    }
    const apiResponse = await response.json();
    return apiResponse;
}
